export default {
  hero: {
    title: "Basetao Spreadsheet — Le guide complet des produits, vendeurs et ressources",
    subtitle:
      "Trouvez, comparez et comprenez les ressources Basetao Spreadsheet en un seul endroit. Explorez des guides pratiques, des informations sur les vendeurs, la recherche de produits, les frais de livraison, l'entrepôt, les coupons, les avis, les conseils QC et la sécurité.",
    trust: "Ressource indépendante · Guides pratiques · Mis à jour régulièrement",
    dropdownLabel: "Parcourir une catégorie",
    dropdownPlaceholder: "Choisissez une catégorie…",
  },
  whatIs: {
    title: "Qu'est-ce que Basetao Spreadsheet ?",
    p1: "Un Basetao Spreadsheet est une base de données de produits organisée qui aide les acheteurs à trouver et comparer les articles disponibles via l'agent d'achat Basetao. Au lieu de faire défiler des milliers d'annonces individuelles, vous pouvez parcourir un document structuré qui regroupe les produits par catégorie et inclut des détails utiles comme les informations sur les vendeurs, les références produits et des notes pratiques.",
    p2: "Pensez-y comme à une carte : il ne vend rien par lui-même, mais il vous aide à comprendre quels produits existent, comment ils sont regroupés et où chercher ensuite. Le spreadsheet est organisé autour de catégories d'achat courantes — chaussures, sweats, t-shirts, vestes, sacs, ceintures et plus — pour affiner rapidement votre recherche vers le type de produit que vous voulez vraiment.",
  },
  article: {
    title: "Guides et ressources",
    subtitle: "Lisez des guides clairs et originaux pour tirer le meilleur parti du Basetao Spreadsheet.",
    cardTitle: "Qu'est-ce que Basetao Spreadsheet ? Guide du débutant",
    cardDesc:
      "Un aperçu complet et accessible : ce qu'est le spreadsheet, ce qu'il contient, comment l'utiliser et ce qu'il faut vérifier avant de commander.",
    readMore: "Lire le guide",
    viewAll: "Voir tous les guides",
    related: "Articles connexes",
    updated: "Mis à jour régulièrement",
  },
  faq: {
    title: "Questions fréquentes",
    q1: "Qu'est-ce que Basetao Spreadsheet ?",
    a1: "C'est une liste organisée par catégories de produits et de références qui aide les acheteurs à rechercher des articles disponibles via l'agent d'achat Basetao.",
    q2: "Comment utiliser Basetao Spreadsheet ?",
    a2: "Ouvrez le spreadsheet, choisissez une catégorie, notez les références produits que vous voulez, comparez les détails des vendeurs, puis vérifiez les prix et la disponibilité actuels sur la plateforme officielle avant de commander.",
    q3: "Basetao est-il légitime ?",
    a3: "Basetao est un agent d'achat bien connu, mais comme avec tout agent, vérifiez toujours vous-même les vendeurs, les produits, les prix et les politiques avant de prendre une décision d'achat.",
    q4: "Combien coûte la livraison Basetao ?",
    a4: "Les frais de livraison dépendent du poids, du volume, de la destination et de la méthode d'expédition choisie. Les tarifs changent avec le temps, vérifiez donc toujours les conditions actuelles avant de commander.",
    q5: "Basetao propose-t-il des coupons ou codes de réduction ?",
    a5: "Des offres peuvent apparaître de temps en temps, mais la disponibilité et l'éligibilité peuvent changer. Vérifiez toujours qu'un code est encore valide avant de vous y fier.",
  },
  ctaSection: {
    title: "Prêt à explorer le spreadsheet complet ?",
    subtitle:
      "Parcourez le catalogue complet, comparez les catégories et commencez à rechercher des produits sur le site principal.",
    button: "Visiter le site principal",
  },
};